import { CircularProgress, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import EditIcon from '@material-ui/icons/Edit';
import Link from '@material-ui/core/Link';
import TextField from '@material-ui/core/TextField';
import MUIDataTable from 'mui-datatables';
import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getDatafromApi, handleCallApi } from './calls';
import { ApiData } from './config';
import uploadIcon from './themes/icons/uploadicon.png';
import { handlePhotoUpload, handleUploadFile } from './uploadFiles';

let selectedRowIndex = [];

const EMPTY_FORM = {
  name: '',
  nameHebrew: '',
  description: '',
  descriptionHebrew: '',
  image: '',
  flag: '',
  traveler_information_english: '',
  traveler_information_hebrew: '',
};

class CountriesMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      countryTableData: [['Loading Data...']],
      searchData: [],
      updateCountryRowIndex: '',
      save_type: 'add',
      openDeleteCnfrm: false,
      editableCountryId: '',
      ...EMPTY_FORM,
    };
  }

  handleCountryValidation = () => {
    const errors = {};
    let formIsValid = true;

    if (!this.state.name) {
      formIsValid = false;
      errors.name = 'Please fill country name';
    }

    this.setState({ errors });
    return formIsValid;
  };

  handleFlagUpload = async (event) => {
    try {
      const url = await handlePhotoUpload(event, 'planmytrip-assets', 'countries');
      if (url) {
        this.setState({ flag: url });
      }
    } catch (error) {
      toast.error('Error uploading flag');
    }
  };

  handleImageUpload = async (event) => {
    try {
      const url = await handlePhotoUpload(event, 'planmytrip-assets', 'countries');
      if (url) {
        this.setState({ image: url });
      }
    } catch (error) {
      toast.error('Error uploading image');
    }
  };

  handleTravelerFileUpload = async (event, field) => {
    try {
      const url = await handleUploadFile(event, 'planmytrip-assets', 'countries/traveler-information');
      if (url) {
        this.setState({ [field]: url });
      }
    } catch (error) {
      toast.error('Error uploading file');
    }
  };

  handleSaveCountry = async (e) => {
    e.preventDefault();
    toast.dismiss();

    if (!this.handleCountryValidation()) {
      toast.error('Missing Information / Fields');
      return;
    }

    const countryData1 = [...this.state.countryTableData];
    const apidata = {
      name: this.state.name,
      nameHebrew: this.state.nameHebrew,
      description: this.state.description,
      descriptionHebrew: this.state.descriptionHebrew,
      image: this.state.image,
      flag: this.state.flag,
      traveler_information_english: this.state.traveler_information_english,
      traveler_information_hebrew: this.state.traveler_information_hebrew,
    };

    let method = 'POST';
    let url = ApiData.baseURL + '/countries';
    let success = 'Country Added';
    if (this.state.save_type !== 'add') {
      method = 'PATCH';
      url = ApiData.baseURL + `/countries/${this.state.editableCountryId}`;
      success = 'Country Updated';
    }

    const data = await handleCallApi(method, url, JSON.stringify(apidata), success, '');
    if (!data) {
      return;
    }

    if (this.state.save_type === 'add') {
      countryData1.push(data);
      this.setState({ countryTableData: countryData1 });
      if (this.state.searchData?.length) {
        this.setState({ searchData: [...this.state.searchData, data] });
      }
    } else {
      if (this.state.searchData?.length) {
        const updatedSearch = [...this.state.searchData];
        updatedSearch[this.state.updateCountryRowIndex] = data;
        this.setState({ searchData: updatedSearch });
      } else {
        countryData1[this.state.updateCountryRowIndex] = data;
        this.setState({ countryTableData: countryData1 });
      }
    }

    this.setState({
      ...EMPTY_FORM,
      save_type: 'add',
      updateCountryRowIndex: '',
      editableCountryId: '',
      errors: {},
    });
    closePopoup();
  };

  setCountryData = async (save_type, updateCountryRowIndex, countryData) => {
    this.setState({
      save_type,
      updateCountryRowIndex,
      ...EMPTY_FORM,
      ...(countryData || {}),
    });
  };

  setCountryTableData = async (data) => {
    this.setState({ countryTableData: data });
  };

  setCountrySearchData = async (data) => {
    this.setState({ searchData: data });
  };

  setEditableCountryId = (id) => {
    this.setState({ editableCountryId: id });
  };

  handleClickOpen = () => {
    if (selectedRowIndex.length > 0) {
      this.setState({ openDeleteCnfrm: true });
    }
  };

  handleDelete = () => {
    this.setState({ openDeleteCnfrm: false });
    const array = [...this.state.countryTableData];
    selectedRowIndex.sort((a, b) => b - a);

    selectedRowIndex.forEach(async (i) => {
      const delid = array[i].id;
      array.splice(i, 1);
      await handleCallApi('DELETE', ApiData.baseURL + `/countries/${delid}`, {}, '', '');
    });

    this.setCountryTableData(array);
    selectedRowIndex = [];
  };

  handleClose = () => {
    this.setState({ openDeleteCnfrm: false });
    selectedRowIndex = [];
  };

  render() {
    return (
      <div>
        <Dialog
          open={this.state.openDeleteCnfrm}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Delete</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are You Sure You Want to delete this Country
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose}>Cancel</Button>
            <Button onClick={this.handleDelete} autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <div className="modal">
          <div className="modal_content">
            <span className="close">&times;</span>
            <div className="model_html">
              <h2>{this.state.save_type === 'add' ? 'CREATE NEW COUNTRY' : `EDIT COUNTRY ${this.state.editableCountryId}`}</h2>
              <table cellPadding="8">
                <tbody>
                  <tr>
                    <td>
                      <label>Name</label><br />
                      <TextField
                        size="small"
                        style={{ width: '95%' }}
                        variant="outlined"
                        value={this.state.name}
                        error={!!this.state.errors.name}
                        onChange={(event) => this.setState({ name: event.target.value })}
                      />
                    </td>
                    <td>
                      <label>Name Hebrew</label><br />
                      <TextField
                        size="small"
                        style={{ width: '95%' }}
                        variant="outlined"
                        value={this.state.nameHebrew}
                        onChange={(event) => this.setState({ nameHebrew: event.target.value })}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>Description</label><br />
                      <TextField
                        multiline
                        rows={3}
                        style={{ width: '95%' }}
                        variant="outlined"
                        value={this.state.description}
                        onChange={(event) => this.setState({ description: event.target.value })}
                      />
                    </td>
                    <td>
                      <label>Description Hebrew</label><br />
                      <TextField
                        multiline
                        rows={3}
                        style={{ width: '95%' }}
                        variant="outlined"
                        value={this.state.descriptionHebrew}
                        onChange={(event) => this.setState({ descriptionHebrew: event.target.value })}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>Image</label><br />
                      <div style={{ marginBottom: '8px' }}>
                        {this.state.image ? (
                          <img src={this.state.image} alt="Country" style={{ maxHeight: '120px', borderRadius: '6px' }} />
                        ) : (
                          <span style={{ color: '#666' }}>No image selected</span>
                        )}
                      </div>
                      <div className="divUpload">
                        <img alt="Upload" width="20px" src={uploadIcon} />
                        <Button variant="contained" component="label" style={{ float: 'right', fontSize: 9 }}>
                          Change Image
                          <input type="file" hidden id="fileCountryImage" value="" onChange={this.handleImageUpload} />
                        </Button>
                      </div>
                    </td>
                    <td>
                      <label>Flag Image</label><br />
                      <div style={{ marginBottom: '8px' }}>
                        {this.state.flag ? (
                          <img src={this.state.flag} alt="Country flag" style={{ maxHeight: '120px', borderRadius: '6px' }} />
                        ) : (
                          <span style={{ color: '#666' }}>No flag selected</span>
                        )}
                      </div>
                      <div className="divUpload">
                        <img alt="Upload" width="20px" src={uploadIcon} />
                        <Button variant="contained" component="label" style={{ float: 'right', fontSize: 9 }}>
                          Change Flag Image
                          <input type="file" hidden id="fileCountryFlag" value="" onChange={this.handleFlagUpload} />
                        </Button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>Traveler Information English</label><br />
                      <div style={{ minHeight: '32px', marginBottom: '8px' }}>
                        {this.state.traveler_information_english ? (
                          <>
                            <a href={this.state.traveler_information_english} target="_blank" rel="noreferrer">
                              {this.state.traveler_information_english.split('/').pop()}
                            </a>
                            <Button
                              size="small"
                              style={{ minWidth: 'unset', padding: '2px 8px', marginLeft: '8px' }}
                              onClick={() => this.setState({ traveler_information_english: '' })}
                            >
                              X
                            </Button>
                          </>
                        ) : (
                          <span style={{ color: '#666' }}>No file selected</span>
                        )}
                      </div>
                      <div className="divUpload">
                        <img alt="Upload" width="20px" src={uploadIcon} />
                        <Button variant="contained" component="label" style={{ float: 'right', fontSize: 9 }}>
                          Change File
                          <input
                            type="file"
                            hidden
                            id="fileTravelerEnglish"
                            value=""
                            onChange={(event) => this.handleTravelerFileUpload(event, 'traveler_information_english')}
                          />
                        </Button>
                      </div>
                    </td>
                    <td>
                      <label>Traveler Information Hebrew</label><br />
                      <div style={{ minHeight: '32px', marginBottom: '8px' }}>
                        {this.state.traveler_information_hebrew ? (
                          <>
                            <a href={this.state.traveler_information_hebrew} target="_blank" rel="noreferrer">
                              {this.state.traveler_information_hebrew.split('/').pop()}
                            </a>
                            <Button
                              size="small"
                              style={{ minWidth: 'unset', padding: '2px 8px', marginLeft: '8px' }}
                              onClick={() => this.setState({ traveler_information_hebrew: '' })}
                            >
                              X
                            </Button>
                          </>
                        ) : (
                          <span style={{ color: '#666' }}>No file selected</span>
                        )}
                      </div>
                      <div className="divUpload">
                        <img alt="Upload" width="20px" src={uploadIcon} />
                        <Button variant="contained" component="label" style={{ float: 'right', fontSize: 9 }}>
                          Change File
                          <input
                            type="file"
                            hidden
                            id="fileTravelerHebrew"
                            value=""
                            onChange={(event) => this.handleTravelerFileUpload(event, 'traveler_information_hebrew')}
                          />
                        </Button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="2">
                      <span className="errorMsg">{this.state.errors.name}</span>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="2">
                      {this.state.save_type === 'add' && (
                        <Button id="btnSaveCountry" variant="contained" color="primary" onClick={this.handleSaveCountry}>
                          CREATE
                        </Button>
                      )}
                      {this.state.save_type !== 'add' && (
                        <Button id="btnSaveCountry" variant="contained" color="primary" onClick={this.handleSaveCountry}>
                          SAVE CHANGES
                        </Button>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
        />
        <table cellPadding="10" className="viewdata">
          <tbody>
            <tr>
              <td><h2>Countries</h2></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td colSpan="3"></td>
              <td>
                <Button
                  id="btnSave"
                  variant="contained"
                  className="deleteBtn"
                  onClick={() => { this.handleClickOpen(); }}
                  style={{ float: 'right', fontSize: 12, color: '#fff' }}
                >
                  DELETE SELECTED
                </Button>
              </td>
            </tr>
            <tr>
              <td colSpan="4">
                <CountriesMasterTable
                  tripData={this.state.countryTableData}
                  searchData={this.state.searchData}
                  setCountryTableData={this.setCountryTableData}
                  setCountrySearchData={this.setCountrySearchData}
                  setCountryData={this.setCountryData}
                  setEditableCountryId={this.setEditableCountryId}
                />
              </td>
            </tr>
            <tr>
              <td colSpan="4">
                <Link href="#" onClick={() => { this.setCountryData('add', '', EMPTY_FORM); openPopup(); }}>+ ADD NEW COUNTRY</Link>
              </td>
            </tr>
            <tr>
              <td colSpan="4"><div className="borderDiv" /></td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

class CountriesMasterTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [['Loading Data...']],
      loading: false,
      page: 0,
      rowsPerPage: 10,
      count: 0,
      filterData: [],
      filterState: false,
      searchTerm: '',
    };
  }

  async componentDidMount() {
    const data = await this.getData();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('id')) {
      const id = urlParams.getAll('id');
      this.props.setEditableCountryId(id[0]);
      this.setCountryData(id, data);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.page !== prevState.page || this.state.rowsPerPage !== prevState.rowsPerPage) {
      const data = await this.getData();
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.has('id')) {
        const id = urlParams.getAll('id');
        this.props.setEditableCountryId(id[0]);
        this.setCountryData(id, data);
      }
    }
  }

  setCountryData = async (id, data) => {
    const filterId = parseInt(id[0], 10);
    const filterRow = await this.getCountryById(filterId);
    const getIndexRow = data.findIndex((row) => row.id === filterId);
    this.props.setCountryData('update', getIndexRow, filterRow);
    openPopup(filterRow.id);
  };

  normalizeCountriesData = (data) => {
    if (Array.isArray(data)) {
      return data;
    }
    if (data && Array.isArray(data.results)) {
      return data.results;
    }
    return [];
  };

  getData = () => {
    this.setState({ loading: true });
    const dataRows = this.xhrRequest(ApiData.baseURL + '/countries').then(async (data) => {
      this.setState({ data, loading: false, count: data.length });
      this.props.setCountryTableData(data);
      return data;
    });
    return dataRows;
  };

  xhrRequest = (url) => new Promise(async (resolve) => {
    const data = await getDatafromApi(url);
    const normalized = this.normalizeCountriesData(data);
    if (normalized) {
      normalized.sort((a, b) => (a.id || 0) - (b.id || 0));
      resolve(normalized);
    }
  });

  getCountryById = (id) => new Promise(async (resolve) => {
    const data = await getDatafromApi(ApiData.baseURL + `/countries/${id}`);
    if (data) {
      resolve(data);
    }
  });

  render() {
    const { page, rowsPerPage, count, data } = this.state;
    const getRowById = (id) => (data || []).find((row) => Number(row.id) === Number(id)) || {};
    const ellipsisStyle = {
      maxWidth: '260px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      display: 'block',
    };
    const thumbnailStyle = {
      width: '86px',
      height: '86px',
      objectFit: 'cover',
      borderRadius: '10px',
    };

    const columns = [
      {
        name: 'id',
        options: {
          label: 'ID',
          filter: false,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            const editrow = getRowById(value);
            const rowIndexForUpdate = tableMeta.rowIndex;

            return (
              <Link href="#" onClick={() => { this.props.setCountryData('update', rowIndexForUpdate, editrow); this.props.setEditableCountryId(value); openPopup(editrow.id); }}>
                {value}
              </Link>
            );
          },
        },
      },
      { name: 'name', label: 'Name', options: { filter: false } },
      { name: 'nameHebrew', label: 'Name Hebrew', options: { filter: false } },
      {
        name: 'description',
        label: 'Description',
        options: {
          filter: false,
          customBodyRender: (value) => <span style={ellipsisStyle}>{value || ''}</span>,
        },
      },
      {
        name: 'image',
        label: 'Image',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => (value ? <img src={value} alt="Country" style={thumbnailStyle} /> : '-'),
        },
      },
      {
        name: 'flag',
        label: 'Flag',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => (value ? <img src={value} alt="Flag" style={thumbnailStyle} /> : '-'),
        },
      },
      {
        name: 'status',
        label: 'Status',
        options: {
          filter: false,
          customBodyRender: (value, tableMeta) => {
            const row = getRowById(tableMeta.rowData[0]);
            const statusValue = value ?? row.status ?? row.active ?? true;
            return String(statusValue);
          },
        },
      },
      {
        name: 'createdAt',
        label: 'Create Date',
        options: {
          filter: false,
          customBodyRender: (value) => <span style={ellipsisStyle}>{value || ''}</span>,
        },
      },
      {
        name: 'id',
        label: 'Edit',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            const editrow = getRowById(value);
            const rowIndexForUpdate = tableMeta.rowIndex;
            return (
              <Link href="#" onClick={() => { this.props.setCountryData('update', rowIndexForUpdate, editrow); this.props.setEditableCountryId(value); openPopup(editrow.id); }}>
                <EditIcon />
              </Link>
            );
          },
        },
      },
    ];

    const onRowsSelect = (curRowSelected, rowsSelected) => {
      selectedRowIndex = [];
      for (let i = 0; i < rowsSelected.length; i++) {
        selectedRowIndex.push(rowsSelected[i].index);
      }
      activeDeactiveDeleteBtn();
    };

    const handleChangePage = (event) => {
      this.setState({ page: event });
    };

    const handleChangeRowsPerPage = (event) => {
      this.setState({ rowsPerPage: event, page: 0 });
    };

    const options = {
      filter: true,
      filterType: 'dropdown',
      responsive: 'standard',
      download: false,
      print: false,
      selectableRowsOnClick: false,
      selectToolbarPlacement: 'none',
      rowsSelected: selectedRowIndex,
      rowsPerPage,
      page,
      count,
      onRowSelectionChange: onRowsSelect,
      onChangePage: handleChangePage,
      onChangeRowsPerPage: handleChangeRowsPerPage,
    };

    return (
      <div>
        <MUIDataTable
          title={(
            <Typography variant="subtitle2">
              {this.state.loading && (
                <CircularProgress
                  size={24}
                  style={{ marginLeft: 15, position: 'relative', top: 4 }}
                />
              )}
            </Typography>
          )}
          data={data}
          columns={columns}
          options={options}
        />
      </div>
    );
  }
}

export default CountriesMaster;

function openPopup(id = '') {
  if (id !== '') {
    window.history.pushState(null, null, `?page=countries&id=${id}`);
  }
  const modal = document.querySelector('.modal');
  const closeBtn = document.querySelector('.close');
  modal.style.display = 'block';
  document.querySelector('.viewdata').style.display = 'none';
  closeBtn.addEventListener('click', () => {
    window.history.pushState(null, null, '?page=countries');
    modal.style.display = 'none';
    document.querySelector('.viewdata').style.display = 'inline-table';
  });
}

function closePopoup() {
  document.querySelector('.modal').style.display = 'none';
  document.querySelector('.viewdata').style.display = 'inline-table';
}

function activeDeactiveDeleteBtn() {
  const btn = document.querySelector('.deleteBtn');
  if (selectedRowIndex.length > 0) btn.style.backgroundColor = 'blue';
  else btn.style.backgroundColor = '#e0e0e0';
}
